import { Box, ListItem, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import StockNumber from "components/StockNumber";

function SpecialCoinRow({ coin }) {
  return (
    <ListItemStyle>
      <CoinName>
        <Typography variant="h5" color="text.main">
          {coin?.coinSourceName}{" "}
          <Typography variant="subtitle1" color="grey.50" component="small">
            / {coin?.coinDestinationName}
          </Typography>
        </Typography>
      </CoinName>

      <CoinStock>
        <StockNumber value={coin?.changePCT24HourBuy} hasArrows={true} />
      </CoinStock>

      <CoinPrice>
        <Typography fontWeight={600} color="success.main">
          <NumberFormats value={coin?.priceBuy} />
        </Typography>

        <Typography variant="h6" fontWeight={600} color="error.main">
          <NumberFormats value={coin?.priceSell} />
        </Typography>
      </CoinPrice>
    </ListItemStyle>
  );
}

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  "&:last-child": {
    borderBottom: `none`,
  },
}));

const CoinName = styled(Box)(() => ({
  flex: "0 0 35%",
  maxWidth: "0 0 30%",
}));

const CoinStock = styled(Box)(() => ({
  flex: "0 0 25%",
  maxWidth: "0 0 30%",
  display: "flex",
  alignItems: "center",
}));

const CoinPrice = styled(Box)(() => ({
  flex: "0 0 40%",
  maxWidth: "0 0 40%",
  textAlign: "right",
}));

export default SpecialCoinRow;
